import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { getJoinedText } from '../string-formatter';

interface AccessibilityDescribedByProps {
  describedById: string | null | undefined
  describedByText: string
}
const useStyles = makeStyles(() => ({
  displayNone: {
    display: 'none'
  }
}));

const AccessibilityDescribedBy = ({ describedById = '', describedByText = '' }: AccessibilityDescribedByProps) => {
  const classes = useStyles();
  const computedId = `${getJoinedText(describedById)}-id`;

  return (
    <Typography id={computedId} className={classes.displayNone}>
      {describedByText}
    </Typography>
  );
};

export default AccessibilityDescribedBy;
